<template>
  <div class="Modal">
    <div class="titulo">
      <p class="titulo__p">
        Welcome to the Online Consulting Management System
      </p>
    </div>
    <font-awesome-icon
      class="icon-title general-title"
      icon="times"
      @click="close"
    />
    <div class="contenido">
      <p class="contenido__p">
        In order to make the consulting process more efficient, during its
        development, progress will be made through
        <span class="resaltado">Phases and Processes,</span> outlined according
        to the requirement, objective and scope of the consulting engagement or
        project.
      </p>
      <p class="contenido__p">
        Each Phase and Process is completed as the information is analyzed and
        processed, the client interacts and the project progresses, keeping a
        record of progress, resources used for this purpose, hours of
        interaction and analysis, as well as reports or corresponding
        deliverables.
      </p>
      <p class="contenido__p">In this interface you can:</p>
      <ul class="contenido__p">
        <li>
          <span class="resaltado">Manage your projects:</span> view general
          project data, objective, location map and time and project progress
          statistics
        </li>
        <li>
          <span class="resaltado">Quick view</span> of the resources associated
          with your projects
        </li>
        <li>
          Go to a specific project and
          <span class="resaltado">start or continue</span> with its progress in
          the corresponding Phase and Process screen
        </li>
        <li>
          <span class="resaltado">View</span> alerts, notifications, and
          calendar
        </li>
        <li>
          Schedule an appointment with the
          <span class="resaltado">expert consultant</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    close() {
      this.$emit("close", false);
    },
  },
};
</script>
<style scoped>
.Modal {
  background: white;
  box-shadow: 0px 0px 15px 1px #707070;
  height: 100%;
  border-radius: 10px;
  padding: 20px;
  position: relative;
}
.titulo__p {
  text-align: center;
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 30px;
  margin: 30px;
}
.contenido__p {
  font-family: PT Sans, sans-serif;
  font-weight: 500;
  margin: 10px;
  font-size: 20px;
}
.resaltado {
  color: #f68b23;
}
.general-title {
  position: absolute;
  top: 30px;
  right: 30px;
  font-size: 25px;
  color: #f68b23;
}
@media (max-width: 600px) {
  .titulo__p {
    font-size: 20px;
  }
  .contenido__p {
    font-size: 15px;
  }
}
</style>